import { Tag } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { daysLeft, expiryColor } from '@/lib/expiry';

const DATE = 'DD.MM.YYYY';

const colorProp = (color: string | undefined) => (color ? { color } : {});

/**
 * Срок годности с подсветкой (ТЗ): ≤ 1 дня (и просрочено) — красный, ≤ 3 — оранжевый.
 * Партия без срока — серая метка: она уходит после партий со сроком (ADR-0005 п.3).
 */
export function ExpiryTag({
  expiresOn,
  days,
}: {
  expiresOn: string | null | undefined;
  /** Дней до конца срока от API; нет — посчитать от сегодняшней даты. */
  days?: number | null | undefined;
}) {
  const { t } = useTranslation();
  if (!expiresOn) return <Tag>{t('expiry.none')}</Tag>;
  const left = days ?? daysLeft(expiresOn);
  const note =
    left < 0
      ? t('expiry.expired', { count: -left })
      : left === 0
        ? t('expiry.today')
        : t('expiry.left', { count: left });
  return (
    <Tag {...colorProp(expiryColor(left))} title={note}>
      {dayjs(expiresOn).format(DATE)} · {note}
    </Tag>
  );
}
